import React from 'react';
import moment from 'moment';
import { Box, Card, Divider, Skeleton, Stack, Typography } from '@mui/material';
import { LenderPerformanceRatioCardsViewModel, LenderPerformanceReportFilters } from '@trnsact/trnsact-shared-types';
import { RATIO_CARDS } from '../../../../constants';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

interface Props {
  ratioCards: LenderPerformanceRatioCardsViewModel | null;
  filters?: LenderPerformanceReportFilters | null;
  loading?: boolean;
}

export const KeyRatioCards = ({ ratioCards, filters, loading }: Props) => {
  const created = filters?.created;
  const period = created
    ? `${moment(created.from).format('MMM D, YYYY')} – ${moment(created.to).format('MMM D, YYYY')}`
    : '';

  return (
    <CardContainer title="Key ratio cards" subTitle={`Performance Summary: ${period}`}>
      <Box
        sx={{
          mt: 1,
          gap: '1rem',
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(4, 1fr)' },
        }}
      >
        {RATIO_CARDS.map(({ key, title, description, format }) => {
          const card = ratioCards?.[key] ?? null;

          return (
            <Card key={key} variant="outlined" sx={{ p: 2 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography fontWeight={500}>{title}:</Typography>
                <Typography variant="h6">{loading ? <Skeleton width={60} /> : card ? format(card) : '—'}</Typography>
              </Stack>

              <Divider sx={{ my: 1 }} />

              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            </Card>
          );
        })}
      </Box>
    </CardContainer>
  );
};
